module.exports = __webpack_public_path__ + "static/media/plug.a7403fb6.png";